import React from 'react';
import { buildDailyShiftSegments } from '../../EmployeeDashboard/Utils/uiGenerators';

/**
 * @typedef {{ qualifier: string, id: number }} OrgJobRef
 * @typedef {{ type: string, orgJobRef: OrgJobRef }} Segment
 * @typedef {{ startDate: string, endDate: string, id: number, segments: Segment[] }} Shift
 * @param {{ shift: Shift }} props
 */
 const ProposableShiftInformation = ({ shift }) => {
    return (
        <div>
            <span className="psi-bold">
                Segments
            </span>
            {buildDailyShiftSegments(shift)}    
        </div>
    )
}

export default ProposableShiftInformation